import { useState } from "react";
import { toast } from "sonner";
import { useDolfinClient } from "@/components/DolfinProvider";
import type { components } from "@dolfin/api-admin";

type SupplierResponse = components["schemas"]["SupplierResponse"];
type ResolvedCategory = components["schemas"]["ResolvedCategoryResponse"];

const RESOURCE_LIMIT = 500;

export function useBillResources() {
  const api = useDolfinClient();
  const [suppliers, setSuppliers] = useState<SupplierResponse[]>([]);
  const [categories, setCategories] = useState<ResolvedCategory[]>([]);
  const [newSupplierOpen, setNewSupplierOpen] = useState(false);

  async function fetchAll() {
    const [suppliersRes, categoriesRes] = await Promise.all([
      api.GET("/v1/suppliers", { params: { query: { Limit: RESOURCE_LIMIT } } }),
      // Read-only here; the category taxonomy is managed in the Portal.
      api.GET("/v1/payables/categories"),
    ]);
    setSuppliers(suppliersRes.data?.data ?? []);
    if (!categoriesRes.data) {
      // Non-fatal, but say so: an empty picker would otherwise read as "no categories".
      toast.error("Failed to load spend categories");
    }
    setCategories(categoriesRes.data ?? []);
  }

  async function refreshSuppliers() {
    const res = await api.GET("/v1/suppliers", {
      params: { query: { Limit: RESOURCE_LIMIT } },
    });
    setSuppliers(res.data?.data ?? []);
  }

  return {
    suppliers,
    categories,
    fetchAll,
    refreshSuppliers,
    newSupplierOpen,
    setNewSupplierOpen,
  };
}
